// 통합 캘린더의 유지보수 일정을 누르면 어디로 가나.
//
// 2026-10-19 오너 — 캘린더에서 잡은 유지보수는 '리포트 · 조치 이력'의 고장 조치 이력, 그 줄로.
// 2026-11-02 오너 — "고장 조치 이력 말고 고객사 리포트쪽으로". 이제 고객사 리포트(그 번호)로 간다.
//   옛 일정 중 리포트가 없는 것은 예전대로 조치 이력으로. 구글 캘린더 설명의 링크(api calendar-plan
//   sheetReportPath)와 같은 주소다.

/** 고객사 리포트 화면에서 그 번호를 찾아 칠한다. */
export function sheetReportHref(no: string): string {
  const q = encodeURIComponent(no);
  return `/field/customer-reports?q=${q}&highlight=${q}`;
}

export function maintenanceHref(so: { id: string; sheetReportNo?: string | null }): string {
  return so.sheetReportNo
    ? sheetReportHref(so.sheetReportNo)
    : `/field/fault-remediations?serviceOrder=${encodeURIComponent(so.id)}`;
}
